import request from '@/utils/request'
// 猜你喜欢
export function getGueesProduct(params) {
  return request({
    url: 'api/z/product/getGueesProduct',
    method: 'post',
    params
  })
}
// 店铺热卖/热销
export function getMchtHotProducts(params) {
  return request({
    url: 'api/z/product/getMchtHotProducts',
    method: 'post',
    params
  })
}
// 会员浏览记录
export function setReadHistory(params) {
  return request({
    url: '/api/z/product/readHistory/create',
    method: 'post',
    params
  })
}
// 创建一键上传记录
export function shareGoodCreate(params) {
  return request({
    url: '/api/z/product/shareGood/create',
    method: 'post',
    params
  })
}
//购买该商品的会员还购买的商品列表
export function getMemberProducts(params) {
  return request({
    url: 'api/z/product/getMemberProducts',
    method: 'post',
    params
  })
}
// 商品详情
export function getProductDetail(params) {
  return request({
    url: 'api/z/product/getProductDetail',
    method: 'post',
    params
  })
}
// 获取商品规格
export function getProductSpec(params) {
  return request({
    url: 'api/z/product/getProductItems',
    method: 'post',
    params
  })
}
// 获取资源位商品列表
export function getPositionProducts(params) {
  return request({
    url: 'api/z/product/getPositionProducts',
    method: 'post',
    params
  })
}

// 获取商品评价列表
export function getProductComments(params) {
  return request({
    url: 'api/z/product/getProductComments',
    method: 'post',
    params
  })
}
// 获取商品订单成交记录
export function getProductTranRecord(params) {
  return request({
    url: 'api/z/product/getProductTranRecord',
    method: 'post',
    params
  })
}
// 添加购物车
export function addCart(data) {
  return request({
    url: 'trolley/add',
    method: 'post',
    data
  })
}
// 商品运费
export function getFreightList(params) {
  return request({
    url: 'freight/getlist',
    method: 'get',
    params
  })
}
// 全部商品
export function getGoods(data) {
  return request({
    url: 'product/getProduct',
    method: 'post',
    data
  })
}
// 店铺全部商品
export function getShopGoods(data) {
  return request({
    url: 'platformApplication/enterShop',
    method: 'post',
    data
  })
}
// 新款
export function getDailyNew(data) {
  return request({
    url: 'product/getDailyNew',
    method: 'post',
    data
  })
}
// 七日热销
export function getSalesArea(data) {
  return request({
    url: 'product/getSalesArea',
    method: 'post',
    data
  })
}
// 编码搜索
export function getProductSkuCode(params) {
  return request({
    url: 'product/getProductSkuCode',
    method: 'get',
    params
  })
}
// 搜索商品
export function searchGoodsList(params) {
  return request({
    url: '/api/z/product/getProductSerchResult',
    method: 'post',
    params
  })
}
// 搜索商品
export function getProductBehalfSerch(params) {
  return request({
    url: '/api/z/product/getProductBehalfSerch',
    method: 'post',
    params
  })
}

// 图片上传 获取相似商品id
export function getLikeId(params) {
  return request({
    url: 'api/z/getLikeId',
    method: 'get',
    params
  })
}
//  以图搜图
export function getMchtProductListById(data) {
  return request({
    url: `api/z/getMchtProductListById?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
    method: 'post',
    data
  })
}
// 获取平台类目
export function getClassifyList(params) {
  return request({
    url: '/api/z/category/getCategoryList',
    method: 'post',
    params
  })
}
// 商品收藏列表
export function getProductCollectList(data) {
  return request({
    url: 'memberCollect/productCollectList',
    method: 'post',
    data
  })
}
// 店铺收藏列表
export function getShopCollectList(data) {
  return request({
    url: 'memberCollect/shopCollectList',
    method: 'post',
    data
  })
}
//常购商品列表
export function accountProduct(params) {
  return request({
    url: 'account/product',
    method: 'get',
    params
  })
}
// 档口市场商家列表
export function getStallMchtShopList(params) {
  return request({
    url: 'api/z/stall/getStallMchtShopList',
    method: 'post',
    params
  })
}
//档口区域筛选列表
export function getStallAreaList(params) {
  return request({
    url: 'api/z/stall/getStallAreaList',
    method: 'post',
    params
  })
}
// 档口筛选列表
export function getProvinceStallList(params) {
  return request({
    url: 'api/z/stall/getProvinceStallList',
    method: 'post',
    params
  })
}
// 店铺信息
export function mchtShopGetMchtBaseInfo(params) {
  return request({
    url: 'api/z/mchtShop/getMchtBaseInfo',
    method: 'post',
    params
  })
}
// 活动商品列表
export function getActivitiesProducts(params) {
  return request({
    url: 'api/z/activities/products',
    method: 'get',
    params
  })
}
// 分页查询活动培训管理列表
export function getActivitiesTrainingList(params) {
  return request({
    url: 'activity/queryPageList',
    method: 'get',
    params
  })
}
// 活动培训详情
export function getActivitiesTrainingDetails(params) {
  return request({
    url: 'activity/details',
    method: 'get',
    params
  })
}
// 活动培训报名
export function applyActivityTraining(data) {
  return request({
    url: 'activity/signup',
    method: 'post',
    data
  })
}
// 拼货活动
export function getSpellGoods(params) {
  return request({
    url: 'spell/activity/goods',
    method: 'get',
    params
  })
}
// 满减活动
export function getReducedGoods(params) {
  return request({
    url: 'api/z/full/reductions/activities/products',
    method: 'get',
    params
  })
}
// 优惠券列表
export function getCouponsGoods(params) {
  return request({
    url: 'api/z/coupons',
    method: 'get',
    params
  })
}
// 促销活动列表
export function getPromotions(params) {
  return request({
    url: 'api/z/promotions',
    method: 'get',
    params
  })
}
// 秒杀时段列表
export function getActivitiesTimes(params) {
  return request({
    url: 'api/z/sec/kill/activities/times',
    method: 'get',
    params
  })
}
// 秒杀商品列表
export function getKillGoodsList(params) {
  return request({
    url: 'api/z/sec/kill/activities/products',
    method: 'get',
    params
  })
}
// 获取活动详情
export function activityDetail(id) {
  return request({
    url: '/activities/' + id,
    method: 'get'
  })
}
// 获取浏览记录
export function browserRecords(params) {
  return request({
    url: '/api/z/product/readHistory',
    method: 'get',
    params
  })
}
// 活动商品列表
export function activityGoodsList(params) {
  return request({
    url: '/api/z/activities/products',
    method: 'get',
    params
  })
}
// 根据活动培训id 更新此数据浏览量
export function updateViews(params) {
  return request({
    url: 'activity/updateViews',
    method: 'get',
    params
  })
}
// 根据商品id获取商品开团列表
export function getSpellGroupByProductId(params) {
  return request({
    url: 'spell/activity/getSpellGroupByProductId',
    method: 'get',
    params
  })
}
// 校验下载数据包

export function checkDownLoad(params) {
  return request({
    url: 'umsIntegrationConsumeRules/checkDownload',
    method: 'post',
    params
  })
}
// 校验下载是否需要扣积分
export function checkMemberIntegral(params) {
  return request({
    url: 'umsIntegrationConsumeRules/checkMemberIntegral',
    method: 'post',
    params
  })
}
